import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-taskpane-tile-menu',
  templateUrl: './taskpane-tile-menu.component.html',
  styleUrls: ['./taskpane-tile-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskpaneTileMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
